import { render, staticRenderFns } from "./MultiselectAttribute.vue?vue&type=template&id=748c69fc"
import script from "./MultiselectAttribute.vue?vue&type=script&lang=js"
export * from "./MultiselectAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports